import { Linkedin, Star, Award, FileText, Github, Globe, Twitter } from "lucide-react";

const FIELDS = [
  { key: "linkedin_url", icon: Linkedin, label: "LinkedIn" },
  { key: "glassdoor_url", icon: Star, label: "Glassdoor" },
  { key: "formdin_url", icon: Award, label: "Formdin / Foundit" },
  { key: "indeed_url", icon: FileText, label: "Indeed" },
  { key: "github_url", icon: Github, label: "GitHub" },
  { key: "portfolio_url", icon: Globe, label: "Portfolio" },
  { key: "twitter_url", icon: Twitter, label: "X / Twitter" },
  { key: "website_url", icon: Globe, label: "Website" },
];

export function formatExternalUrl(url) {
  if (!url) return "#";
  const trimmed = String(url).trim();
  if (!trimmed) return "#";
  if (/^(https?:\/\/|mailto:|tel:)/i.test(trimmed)) return trimmed;
  if (/^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  // Safely format dummy testing words or arbitrary text as external web links
  return `https://www.google.com/search?q=${encodeURIComponent(trimmed)}`;
}

export default function SocialLinks({ profile, theme }) {
  const active = FIELDS.filter(f => profile?.[f.key]);
  if (!active.length) return null;

  const handleLinkClick = (e, rawUrl) => {
    e.preventDefault();
    e.stopPropagation();
    const targetUrl = formatExternalUrl(rawUrl);
    if (targetUrl && targetUrl !== "#") {
      window.open(targetUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
      {active.map(f => {
        const rawVal = profile[f.key];
        const formattedUrl = formatExternalUrl(rawVal);
        return (
          <a
            key={f.key}
            href={formattedUrl}
            target="_blank"
            rel="noreferrer"
            title={`${f.label}: ${rawVal}`}
            onClick={(e) => handleLinkClick(e, rawVal)}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: 32, height: 32, borderRadius: 8, textDecoration: "none",
              background: theme.surfaceRaised, border: `1px solid ${theme.line}`, color: theme.accent,
            }}
          >
            <f.icon size={15} />
          </a>
        );
      })}
    </div>
  );
}
